export default __webpack_public_path__ + "static/media/SEO.e6da2b05.png";